<template>
  <ul class="sidebar navbar-nav">
    <li class="nav-item" :class="{ active: index == 1 }">
      <a class="nav-link" href="#" @click.prevent="changeIndex(1)">
        <i class="fas fa-address-card"></i>
        <span>
          <!-- Thông tin chung -->
          General Information
        </span>
      </a>
    </li>

    <li class="nav-item" :class="{ active: index == 4 }" v-show="item != null">
      <a class="nav-link" href="#" @click.prevent="changeIndex(4)">
        <i class="fas fa-file-contract fa-lg"></i>
        <span>
          <!-- Hợp đồng <br/> lao động -->
          Labor<br />Contract
        </span>
      </a>
    </li>
    <!-- <li class="nav-item" :class="{ active: index == 5}" v-show="item != null">
        <a class="nav-link" href="#" @click.prevent="changeIndex(5)">
          <i class="fas fa-user"></i>
          <span>Quá trình công tác</span>
        </a>
      </li>  -->
    <li class="nav-item" :class="{ active: index == 12 }" v-show="item != null">
      <a class="nav-link" href="#" @click.prevent="changeIndex(12)">
        <i class="fas fa-laptop"></i>
        <span>
          Assets
          <!-- Tài sản -->
        </span>
      </a>
    </li>

    <!-- Permission khenthuong_read -->
    <li
      v-if="true"
      class="nav-item"
      :class="{ active: index == 30 }"
      v-show="item != null"
    >
      <a class="nav-link" href="#" @click.prevent="changeIndex(30)">
        <i class="fas fa-motorcycle"></i>
        <span>
          Parking<br />Information
          <!-- Thông tin<br/>gửi xe -->
        </span>
      </a>
    </li>
    <li
      v-if="khenthuong_read"
      class="nav-item"
      :class="{ active: index == 13 }"
      v-show="item != null"
    >
      <a class="nav-link" href="#" @click.prevent="changeIndex(13)">
        <i class="fas fa-user-plus"></i>
        <span>
          Reward
          <!-- Khen thưởng -->
        </span>
      </a>
    </li>
    <li
      v-if="kyluat_read"
      class="nav-item"
      :class="{ active: index == 14 }"
      v-show="item != null"
    >
      <a class="nav-link" href="#" @click.prevent="changeIndex(14)">
        <i class="fas fa-user-minus"></i>
        <span>
          Discipline
          <!-- Kỷ luật -->
        </span>
      </a>
    </li>
    <li
      v-if="daotao_read"
      class="nav-item"
      :class="{ active: index == 15 }"
      v-show="item != null"
    >
      <a class="nav-link" href="#" @click.prevent="changeIndex(15)">
        <i class="fas fa-user-graduate"></i>
        <span>
          Training
          <!-- Đào tạo -->
        </span>
      </a>
    </li>
    <!-- <li class="nav-item" :class="{ active: index == 16}" v-show="item != null">
        <a class="nav-link" href="#" @click.prevent="changeIndex(16)">
          <i class="fas fa-user"></i>
          <span>Bằng cấp</span>
        </a>
      </li>  -->
    <li
      v-if="bangcap_read"
      class="nav-item"
      :class="{ active: index == 17 }"
      v-show="item != null"
    >
      <a class="nav-link" href="#" @click.prevent="changeIndex(17)">
        <i class="fas fa-file-alt"></i>
        <span>
          Qualifications
          <!-- Bằng cấp/<br/>Chứng chỉ -->
        </span>
      </a>
    </li>
    <li
      v-if="tailieu_read"
      class="nav-item"
      :class="{ active: index == 27 }"
      v-show="item != null"
    >
      <a class="nav-link" href="#" @click.prevent="changeIndex(27)">
        <i class="fas fa-folder-open"></i>
        <span>
          Attachments
          <!-- Tài liệu <br/> đính kèm -->
        </span>
      </a>
    </li>
    <!-- <li class="nav-item" :class="{ active: index == 29}" v-show="item != null">
        <a class="nav-link" href="#" @click.prevent="changeIndex(29)">
          <i class="fas fa-user"></i>
          <span>Đánh giá</span>
        </a>
      </li>-->
  </ul>
</template>

<script>
export default {
  name: "EmployeeSidebar",
  props: ["item", "index"],
  data() {
    return {
      // index: 1,
    };
  },
  computed: {
    //Permission view Khen thuong-Ky luat-DaoTao-BangCap-Tailieu
    khenthuong_read() {
      return this.$store.getters.hasPermission("khenthuong_read");
    },
    kyluat_read() {
      return this.$store.getters.hasPermission("kyluat_read");
    },
    daotao_read() {
      return this.$store.getters.hasPermission("daotao_read");
    },
    bangcap_read() {
      return this.$store.getters.hasPermission("bangcap_read");
    },
    tailieu_read() {
      return this.$store.getters.hasPermission("tailieu_read");
    },
  },
  methods: {
    goBack() {
      this.$router.push("/hr_record");
      // this.$router.go(-1);
    },
    changeIndex(data) {
      // this.index = data;
      this.$emit("index", data);
      this.$emit("changeIndexChild", data);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
